(() => {
  const root = document.documentElement;
  const drawer = document.getElementById('AyaCartDrawer');
  const drawerItems = drawer ? drawer.querySelector('[data-cart-items]') : null;
  const drawerFooter = drawer ? drawer.querySelector('[data-cart-footer]') : null;
  const drawerSubtotal = drawer ? drawer.querySelector('[data-cart-subtotal]') : null;

  const formatMoney = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || window.AyaTheme.currency || 'USD'
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  };

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    refreshCart();
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  };

  const cartRoot = () => {
    const base = window.AyaTheme && window.AyaTheme.rootUrl ? window.AyaTheme.rootUrl : '/';
    return base.endsWith('/') ? base : `${base}/`;
  };

  const renderCart = (cart) => {
    if (!drawerItems || !drawerFooter) return;
    updateCartCount(cart.item_count || 0);

    if (!cart.items || !cart.items.length) {
      drawerItems.innerHTML = `<div class="empty-state"><p>${window.AyaTheme.strings.emptyCart}</p></div>`;
      drawerFooter.hidden = true;
      return;
    }

    drawerFooter.hidden = false;
    drawerSubtotal.textContent = formatMoney(cart.total_price, cart.currency);
    drawerItems.innerHTML = cart.items.map((item, index) => {
      const image = item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '<div></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-meta">${escapeHtml(item.variant_title)}</div>` : '';
      return `
        <div class="cart-drawer__item">
          <a href="${item.url}">${image}</a>
          <div>
            <a class="cart-drawer__item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
            ${variant}
            <div class="cart-drawer__item-row">
              <div class="cart-drawer__qty" aria-label="Quantity">
                <button type="button" data-cart-change="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">&minus;</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
              </div>
              <strong>${formatMoney(item.final_line_price, cart.currency)}</strong>
            </div>
            <button class="cart-drawer__remove" type="button" data-cart-change="${index + 1}" data-quantity="0">${window.AyaTheme.strings.remove}</button>
          </div>
        </div>`;
    }).join('');
  };

  const escapeHtml = (value) => {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  };

  const refreshCart = async () => {
    try {
      const response = await fetch(`${cartRoot()}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load cart');
      renderCart(await response.json());
    } catch (error) {
      if (drawerItems) drawerItems.innerHTML = '<p class="muted">Unable to load cart.</p>';
    }
  };

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-cart-open]');
    if (open) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const change = event.target.closest('[data-cart-change]');
    if (change) {
      event.preventDefault();
      change.disabled = true;
      try {
        const response = await fetch(`${cartRoot()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(change.dataset.cartChange), quantity: Number(change.dataset.quantity) })
        });
        if (!response.ok) throw new Error('Unable to update cart');
        renderCart(await response.json());
      } catch (error) {
        await refreshCart();
      }
      return;
    }

    const menuButton = event.target.closest('[data-mobile-menu]');
    if (menuButton) {
      const nav = document.getElementById('AyaMobileNav');
      if (!nav) return;
      const openState = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', openState ? 'true' : 'false');
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const original = button ? button.textContent : '';
    if (button) button.disabled = true;

    try {
      const formData = new FormData(form);
      const response = await fetch(`${cartRoot()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Unable to add item');
      }
      openDrawer();
    } catch (error) {
      window.alert(error.message);
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = original;
      }
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const option = select.options[select.selectedIndex];
    const form = select.closest('form');
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    const price = document.querySelector('[data-product-price]');
    const addButton = form ? form.querySelector('[type="submit"]') : null;
    if (idInput) idInput.value = option.value;
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (addButton) {
      const available = option.dataset.available === 'true';
      addButton.disabled = !available;
      addButton.textContent = available ? window.AyaTheme.strings.addToCart : window.AyaTheme.strings.soldOut;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  refreshCart();
  root.classList.add('js');
})();

// AYA multilingual selector
// Shopify localization forms require the selected language in language_code.
document.addEventListener('click', (event) => {
  const languageOption = event.target.closest('[data-language-option]');
  if (!languageOption) return;

  const form = languageOption.closest('form');
  const languageInput = form ? form.querySelector('[data-language-code]') : null;
  if (!form || !languageInput) return;

  languageInput.value = languageOption.dataset.languageOption;
  form.submit();
});
